/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/146-wrench': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M15.671 12.779L8.475 6.611A4.5 4.5 0 003.193.193l2.6 2.6a1.003 1.003 0 010 1.414L4.207 5.793a1.003 1.003 0 01-1.414 0l-2.6-2.6a4.5 4.5 0 006.418 5.282l6.168 7.196a.914.914 0 001.358.052l1.586-1.586a.914.914 0 00-.052-1.358z"/>'
  }
})
